// Phase B.3 — Frontend permission helpers.
// Reads `perm_keys` from the logged-in user (set by /api/auth/login).
// Backward-compat: if `perm_keys` is missing (legacy session), returns true so
// existing UIs never break. Admin always returns true.

export function hasPerm(user, key) {
  if (!user) return false;
  if (user.role === "admin") return true;
  // Legacy session — perm_keys not yet populated. Fall back to allow (ROLE_ACCESS still gates the route).
  if (!Array.isArray(user.perm_keys)) return true;
  return user.perm_keys.includes(key);
}

export function hasAnyPerm(user, keys = []) {
  return keys.some((k) => hasPerm(user, k));
}

export function hasAllPerms(user, keys = []) {
  return keys.every((k) => hasPerm(user, k));
}

// Convenience hook-like helper (no React hooks; just curried)
export function usePerm(user) {
  return {
    has: (key) => hasPerm(user, key),
    hasAny: (keys) => hasAnyPerm(user, keys),
    hasAll: (keys) => hasAllPerms(user, keys),
  };
}

export default hasPerm;
